module.exports = __webpack_public_path__ + "img/loading-dark.66be585f.svg";